/* eslint-disable jsx-a11y/media-has-caption */

import { ReactElement } from 'react';

import Slider, { Settings } from 'react-slick';

import { IProps } from './types';
import * as S from './styles';

const sliderSettings: Settings = {
  arrows: true,
  autoplay: false,
  dots: false,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 1000,
};

export function SliceMediaSlider({ slice: { fields } }: IProps): ReactElement {
  return (
    <S.Wrapper className="slice-item slice-media-slider">
      <Slider {...sliderSettings}>
        {fields?.map((item, i) => {
          const { media, media_type } = item;
          return (
            <S.Item
              className="slice-media-slider__item"
              key={`slide_item_${i}`}
            >
              {media_type === 'video' && (
                <video controls>
                  <source src={(media as any).url} />
                </video>
              )}
              {media_type === 'img' && (
                <img src={(media as any).url} alt="Img" />
              )}
            </S.Item>
          );
        })}
      </Slider>
    </S.Wrapper>
  );
}

SliceMediaSlider.componentName = 'mediaslider';
